<template>
	<div>
	<InformationSection id="buildFund" :sections='information' />

		<AttachmentSection :files='files' v-if='files' />
	</div>
</template>

<script>
import ContentService from '@/services/ContentService'

import InformationSection from '@/components/base/InformationSection'
import AttachmentSection from '@/components/base/AttachmentSection'

export default {
	name: 'buildFund',

	components: {
		InformationSection,
		AttachmentSection
	},

	metaInfo: {
    	title: 'Capacity Building Fund'
  	},

	data() {
		return {
			information: [],
			files: []
		}
	},
	async created() {
		const { section1, section2, section3, files} = await ContentService.get('buildFund')

		this.files = files
		this.information.push({ title: 'AIM AND PURPOSE FOR THE PRIMAR S-100 CAPACITY BUILDING FUND', text: section1 })
		this.information.push({ title: 'CRITERIA FOR THE USE OF THE PRIMAR S-100 CAPACITY BUILDING FUND', text: section2 })
		this.information.push({ title: 'APPROVED S-100 CAPACITY BUILDING ACTIVITIES', text: section3 })

	},
}
</script>

<style>
</style>